export default __webpack_public_path__ + "fonts/ic-visa-ele.svg";